import { Skeleton } from '@mui/material';
import { Box } from 'shared/mui/Box';

type Props = {
  enableAdditionalFields?: boolean;
};

export function GatewayRulesFormSkeletonMappingHead({
  enableAdditionalFields = false,
}: Props): JSX.Element {
  return (
    <>
      <Box display="flex" gap="16px" justifyContent="space-between" paddingBottom="24px">
        <Skeleton height={40} sx={{ flexGrow: 1 }} variant="rounded" />
        <Skeleton height={40} variant="rounded" width={40} />
        <Skeleton height={40} sx={{ flexGrow: 1 }} variant="rounded" />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, margin: '0 16px' }}>
          <Skeleton height={24} variant="rounded" width={44} />
          <Skeleton height={20} variant="text" width={64} />
        </Box>
        <Skeleton height={24} variant="rounded" width={24} />
      </Box>
      {enableAdditionalFields && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '16px',
            alignSelf: 'stretch',
            paddingBottom: '20px',
          }}
        >
          <Skeleton height={40} sx={{ minWidth: '153px', maxWidth: '153px' }} variant="rounded" />
          <Skeleton height={40} sx={{ flexGrow: 1 }} variant="rounded" />
          <Skeleton height={40} sx={{ flexGrow: 1 }} variant="rounded" />
        </Box>
      )}
    </>
  );
}
